const task = [{
  desc: '保单任务查询',
  options: {
    url: '/export/getExportTaskByParams',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '添加一个导出任务',
  options: {
    url: '/export/addExportTask',
    method: 'post'
  }
}, {
  desc: '保单修改任务',
  options: {
    url: '/export/updateExportTask',
    method: 'post'
  }
}, {
  desc: '上次有效备份',
  options: {
    url: '/export/getLastDataBackupTask',
    method: 'post'
  }
}, {
  desc: '查看单个任务(查看明细)',
  options: {
    url: '/export/getExportTask',
    method: 'post'
  }
}, /*  {
  desc: '上传接口',
  options: {
    url: '/upload/uploadFile',
    method: 'post'
  }
},  {
  desc: '下载接口',
  options: {
    url: '/upload/downloadFile',
    method: 'get',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'arraybuffer'
  }
} */ {
  desc: '删除备份任务',
  options: {
    url: '/export/deleteExportTask',
    method: 'post'
  }
}, {
  desc: '添加一个删除任务',
  options: {
    url: '/export/addDeleteTask',
    method: 'post'
  }
}, {
  desc: '更新、删除任务',
  options: {
    url: '/export/updateBusiTask',
    method: 'post'
  }
}, {
  desc: '下载文件',
  options: {
    url: '/export/downloadFile',
    responseType: 'arraybuffer'
  }
}, {
  desc: '数据备份（自动备份）关闭',
  options: {
    url: '/export/shutdownAutoDataBackupTask',
    method: 'post'
  }
}, {
  desc: '数据备份（自动备份）开启',
  options: {
    url: '/export/turnOnAutoDataBackupTask',
    method: 'post'
  }
}, {
  desc: '非车保单批量删除',
  options: {
    url: '/export/addFcDeleteTask',
    method: 'post'
  }
}]
export default task



// WEBPACK FOOTER //
// ./src/api/task.js